export const getGroupItemsMarkup = (items = {}) => {
  return Object.values(items).map((groupId) => {
    if (typeof groupId !== `string`) {
      groupId = groupId.id;
    }

    const accessory = window.groupData[groupId];

    if (!accessory) {
      return ``;
    }

    return (
      `<li class="group-page__groupItem">
        <a class="group-page__groupLink" href="${accessory.link}">
          <img class="group-page__groupImg" src="${accessory.image}" alt="${accessory.name}">
          <p class="group-page__groupTitle">${accessory.name}</p>
        </a>
      </li>`
    );
  }).join(`\n`);
};
